import React from 'react';
import { ReservationForm } from '@components';
import { Container } from '@mui/material';

const NewReservationPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ pt: 12, pb: 4 }}>
      <ReservationForm isModal={false} />
    </Container>
  );
};

export default NewReservationPage;